import "./MenuAppsGroup.scss"

import StreamAPISocket from "@/api/stable/APISocket"
import { MenuAppInstance, MenuAppType, MenuClient } from "@/entities/app/menu/menu.types"
import Tumbler from "@/shared/components/extrinsic/Tumbler/Tumbler"
import Icon from "@/shared/components/intrinsic/Icon/Icon"
import { classWithModifiers } from "@/utils/common"


interface MenuAppsGroupProps {
  appId: string
  instances: MenuAppInstance[]

  active?: boolean
  instanceId?: string
  activeList: MenuClient[]
  onSelect?(id: string): void
}

function MenuAppsGroup(props: MenuAppsGroupProps) {

  const source = new StreamAPISocket("AdminPanel")

  return (
    <div className="menu-apps-group">
      {props.instances.map(instance => (
        <div key={instance.id} className="app-instance">
          <div className="app-instance__header">
            <div className="app-instance-title">
              <Icon name={(instance.events?.length ?? 0) > 0 ? "calendar_success" : "calendar_pending"} />
              {instance.type === MenuAppType.MENU ? "Menu App 1" : "Menu App 2"}
            </div>
            <div className="app-instance__actions">
              <div className="app-instance__toggle">
                <button
                  type="button"
                  onClick={() => { source.socket.emit("REFRESH_MENUAPP", { appId: instance.name, menuAppType: instance.type }) }}
                  key={instance.id}
                  title="Refresh"
                >
                  <Icon name="refresh" />
                </button>
                <button
                  type="button"
                  className={classWithModifiers("menu-apps-group__instance", props.instanceId === instance.id && "active")}
                  onClick={() => props.onSelect?.(instance.id)}
                  key={instance.id}
                >
                  <Icon name="image" />
                </button>

                <Tumbler checked={props.activeList.some((app) => (app.appType === instance.type))} readonly={true} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MenuAppsGroup
